import FormActions from './actions'
export default {
  namespaced: true,
  actions: FormActions
}
